import { Scan as ScanType } from "@/lib/types/scan";
import { formatDate } from "@/lib/utils";
import { ActionIcon, Menu, MenuDropdown, MenuItem, MenuTarget } from "@mantine/core";
import { FaEllipsisVertical } from "react-icons/fa6";
import { LoadableImage } from "../atoms/LoadableImage";
import { CardGray } from "../atoms/CardGray";

type Props = {
  scan: ScanType;
  onSetAsCover: (scan: ScanType) => void;
}

export const Scan = ({ scan, onSetAsCover }: Props) => {
  return (
    <CardGray className="flex flex-col gap-2 p-0 overflow-hidden">
      <div className="relative aspect-square w-full">
        <Menu position="bottom-end">
          <MenuTarget>
            <ActionIcon variant="light" className="absolute top-2 right-2 z-10 rounded-lg">
              <FaEllipsisVertical />
            </ActionIcon>
          </MenuTarget>
          <MenuDropdown>
            <MenuItem onClick={() => onSetAsCover(scan)}>
              Set as cover
            </MenuItem>
          </MenuDropdown>
        </Menu>
        <LoadableImage src={`/api/scan/${scan.id}`} loading="lazy" />
      </div>
      <div className="text-center text-muted text-sm pb-2">
        <span>{formatDate(scan.createdAt)}</span>
      </div>
    </CardGray>
  )
}
